import { Tooltip, Typography } from "@mui/material"

type Props = {
  teamRole: 'author' | 'coauthor' | 'member'
  roleLabel?: string | null
  isAuthor?: boolean
  entity?: 'project' | 'team'
}

const roleCaptionSx = {
  fontSize: 10,
  lineHeight: '14px',
  color: 'text.secondary',
  textAlign: 'left',
} as const

function roleCaption(
  teamRole: Props['teamRole'],
  roleLabel: string | null | undefined,
  entity: NonNullable<Props['entity']>
): string {
  if (teamRole === 'coauthor') {
    return entity === 'team' ? 'Сооснователь' : 'Соавтор'
  }
  const label = (roleLabel ?? '').trim()
  return label.length > 0 ? label : 'Участник'
}

function authorCaption(roleLabel: string | null | undefined, entity: NonNullable<Props['entity']>): string {
  const label = (roleLabel ?? '').trim()
  if (label.length > 0) {
    return label
  }
  return entity === 'team' ? 'Основатель' : 'Автор'
}

export const ProjectTeamRoleChip = ({
  teamRole,
  roleLabel,
  isAuthor,
  entity = 'project',
}: Props) => {
  const isAuthorRow = Boolean(isAuthor) || teamRole === 'author'
  const caption = isAuthorRow
    ? authorCaption(roleLabel, entity)
    : roleCaption(teamRole, roleLabel, entity)

  const showCoauthorTooltip = !isAuthorRow && teamRole === 'coauthor' && entity === 'project'

  const text = (
    <Typography variant="black-12-light" sx={roleCaptionSx} component="span">
      {caption}
    </Typography>
  )

  if (showCoauthorTooltip) {
    return (
      <Tooltip title="Соавтор — публичный статус, не права администратора">
        {text}
      </Tooltip>
    )
  }

  return text
}
